//@flow

export const LETTER_COUNT_FOR_TITLE: number = 42;
export const LETTER_COUNT_FOR_DESC: number = 50;



// WEBPACK FOOTER //
// ./src/constants/lettersCount.js